import { render, staticRenderFns } from "./projectBindComapny.vue?vue&type=template&id=5e22e38c&scoped=true&"
import script from "./projectBindComapny.vue?vue&type=script&lang=js&"
export * from "./projectBindComapny.vue?vue&type=script&lang=js&"
import style0 from "./projectBindComapny.vue?vue&type=style&index=0&id=5e22e38c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e22e38c",
  null
  
)

export default component.exports